/**
 * @author Sanjay <sanjay.krishnamurthy@314ecorp.com>
 * @description useBatch
 */
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import EventBus, { Events, Messages } from '@dexit/common/utils/EventBus';
import api from 'client/index';
import { GetBatchesResponseModel } from '@dexit/common/openapi';

export const QUERY_BATCHES_KEY = 'query-batches';

const useBatches = (
	queueId?: string,
	batchId?: string[],
	options?: UseQueryOptions<
		Promise<GetBatchesResponseModel[]>,
		unknown,
		GetBatchesResponseModel[],
		(string | undefined)[]
	>,
): UseQueryResult<GetBatchesResponseModel[], unknown> => {
	return useQuery({
		queryKey: [QUERY_BATCHES_KEY, JSON.stringify(batchId), queueId],
		queryFn: async () => {
			if (!queueId) {
				throw new Error('Queue ID not found');
			}
			const { data } = await api.QueuesApi.getBatches(queueId, batchId);
			return data;
		},
		...options,
		onError: () => {
			EventBus.publish(Events.M_Error, Messages.Error);
		},
	});
};

export default useBatches;
